import { jsx as o, jsxs as f } from "react/jsx-runtime";
import $, { useRef as I, useState as u, useEffect as h } from "react";
import { styled as t, css as v } from "styled-components";
import { u as N } from "../chunks/useForwardRef.7bf5d172.js";
import { e as P, f as R } from "../chunks/vendor_rango__tokens.38ee67b0.js";
const i = {
  SM: "SM",
  LG: "LG"
}, D = t.div.withConfig({
  displayName: "Host",
  componentId: "sc-13akk0w-0"
})(["display:inline-flex;"]), c = t.span.withConfig({
  displayName: "Value",
  componentId: "sc-13akk0w-1"
})(["color:var(--text-label-color);position:absolute;display:flex;height:var(--size-indicator);width:var(--size-indicator);align-items:center;justify-content:center;"]), a = t.circle.withConfig({
  displayName: "TrackCircle",
  componentId: "sc-13akk0w-2"
})(["stroke:var(--elements-bg-color-02);"]), s = t.circle.withConfig({
  displayName: "IndicatorCircle",
  componentId: "sc-13akk0w-3"
})(["display:none;stroke:var(--elements-bg-color-03);transition-property:all;transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-01);"]), l = t.svg.withConfig({
  displayName: "Svg",
  componentId: "sc-13akk0w-4"
})(["width:100%;height:100%;fill:none;transform:rotate(-90deg);", ",", "{fill:transparent;}", "{stroke:var(--elements-bg-color-02);}", "{stroke:var(--elements-bg-color-04);transition-property:all;transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-01);}"], a, s, a, s), V = t.div.withConfig({
  displayName: "RangoProgressCircle",
  componentId: "sc-13akk0w-5"
})(["*{margin:0;padding:0;}display:flex;align-items:center;justify-content:center;border-radius:var(--border-radius-circular);position:relative;", " ", ""], ({
  size: e
}) => e === i.SM && v`
      width: var(--size-6x);
      height: var(--size-6x);

      & > ${c} {
        ${P}
      }

      & > ${l} {
        ${a}, ${s} {
          stroke-width: 4px;
          cx: calc(var(--size-6x) / 2);
          cy: calc(var(--size-6x) / 2);
          r: calc(var(--size-6x) / 2 - 2px);
        }
      }
    `, ({
  size: e
}) => e === i.LG && v`
      width: var(--size-15x);
      height: var(--size-15x);

      & > ${c} {
        ${R}
      }

      & > ${l} {
        ${a}, ${s} {
          stroke-width: 4px;
          cx: calc(var(--size-15x) / 2);
          cy: calc(var(--size-15x) / 2);
          r: calc(var(--size-15x) / 2 - 2px);
        }
      }
    `), L = $.forwardRef(({
  value: e = 0,
  showValue: d = !1,
  size: n = i.SM,
  ...x
}, y) => {
  const k = N(y), r = I(null), [w, p] = u(0), [C, g] = u(0);
  h(() => {
    r.current.style.display = "none", p(0), g(0);
  }, [n]), h(() => {
    b();
  }, [e, d, n]);
  const b = () => {
    setTimeout(() => {
      if (!r.current)
        return;
      const z = getComputedStyle(r == null ? void 0 : r.current).getPropertyValue("r").split("px")[0], m = Math.PI * (Number(z) * 2), S = m * ((100 - e) / 100) * -1;
      p(m), g(S), r.current.style.display = "inline-flex";
    }, 100);
  };
  return /* @__PURE__ */ o(D, { children: /* @__PURE__ */ f(V, { size: i[n], ref: k, title: "progress-circle", role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": e, "data-testid": "rango-progress-circle", "data-rango-component": "rango-progress-circle", "data-is-rango": !0, ...x, children: [
    /* @__PURE__ */ f(l, { children: [
      /* @__PURE__ */ o(a, {}),
      /* @__PURE__ */ o(s, { ref: r, strokeDasharray: w, strokeDashoffset: C })
    ] }),
    d && /* @__PURE__ */ o(c, { children: `${e}%` })
  ] }) });
});
L.displayName = "RangoProgressCircle";
export {
  L as RangoProgressCircle
};
